import React, { createContext, ReactNode, useContext } from "react";
import { SocialSignInResponseType } from "../../../../libraries/types_interface/social/LoginSocialConnectTypes";
import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";

type SignupThirdPartySelectionContextType = {
  socialGoogleSuccess: (detail: SocialSignInResponseType) => void;
};

const SignupThirdPartySelectionContext = createContext<
  SignupThirdPartySelectionContextType | undefined
>(undefined);

export const SignupThirdPartySelectionContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const socialGoogleSuccess = (detail: SocialSignInResponseType) => {
    console.log(detail);

    SessionStorage.saveValue(
      StorageKeys.signup_third_party_connect_detail,
      JSON.stringify(detail)
    );

    navigate(appRoutes.routeNameSignupPersonalInfo, {
      replace: true,
    });
  };

  return (
    <SignupThirdPartySelectionContext.Provider
      value={{
        socialGoogleSuccess,
      }}
    >
      {children}
    </SignupThirdPartySelectionContext.Provider>
  );
};

// IMPORT / USE CONTEXT ///////////////////////////////////////////////////////////////////
export const SignupThirdPartySelectionContextImport = () => {
  const context = useContext(SignupThirdPartySelectionContext);
  if (!context) {
    throw new Error(
      "SignupThirdPartySelectionContextImport must be used within a SignupThirdPartySelectionContextProvider"
    );
  }
  return context;
};
